<template>
  <div
    :class="className"
    class="share-modal"
  >
    <div>
      <ul class="btns-share">
        <!-- used to determine if it should be rendered -->
        <li v-if="buildLinkWaMobile">
          <a
            :href="buildLinkWaMobile"
            class="btn-share btn-share-whatsapp"
            target="_blank"
            :title="$t('common:shareButtons.shareWhatsApp')"
            :aria-label="$t('common:shareButtons.shareWhatsApp')"
          >
            <i class="icon"><icon-whatsapp /></i>
            <span>
              {{ $t('common:socialMedia.platforms.wa') }}
            </span>
          </a>
        </li>
        <!-- used to determine if it should be rendered -->
        <li
          v-if="buildLinkFbMsg"
          class="d-lg-none"
        >
          <a
            :href="buildLinkFbMsg"
            class="btn-share btn-share-facebook"
            target="_blank"
            :title="$t('common:shareButtons.shareFbMsg')"
            :aria-label="$t('common:shareButtons.shareFbMsg')"
          >
            <i class="icon"><icon-brands-facebook-messenger /></i>
            <span>
              {{ $t('common:socialMedia.platforms.fbMessenger') }}
            </span>
          </a>
        </li>
        <!-- used to determine if it should be rendered -->
        <li v-if="buildLinkFb">
          <a
            :href="buildLinkFb"
            class="btn-share btn-share-facebook"
            target="_blank"
            :title="$t('common:shareButtons.shareFacebook')"
            :aria-label="$t('common:shareButtons.shareFacebook')"
          >
            <i class="icon"><icon-brands-facebook /></i>
            <span>
              {{ $t('common:socialMedia.platforms.fb') }}
            </span>
          </a>
        </li>
        <!-- used to determine if it should be rendered -->
        <li
          v-if="buildLinkSms"
          class="d-lg-none"
        >
          <a
            :href="buildLinkSms"
            class="btn-share btn-share-text"
            :title="$t('common:shareButtons.shareSms')"
            :aria-label="$t('common:shareButtons.shareSms')"
          >
            <i class="icon"><icon-sms /></i>
            <span>
              {{ $t('common:socialMedia.platforms.sms') }}
            </span>
          </a>
        </li>
        <!-- used to determine if it should be rendered -->
        <li v-if="buildLinkEmail">
          <a
            class="btn-share btn-share-email"
            :href="buildLinkEmail"
            :title="$t('common:shareButtons.shareEmail')"
            :aria-label="$t('common:shareButtons.shareEmail')"
          >
            <i class="icon"><icon-envelope-alternative-two /></i>
            <span>
              {{ $t('common:socialMedia.platforms.eMail') }}
            </span>
          </a>
        </li>
        <!-- used to determine if it should be rendered -->
        <li v-if="buildLinkTwitter">
          <a
            :href="buildLinkTwitter"
            class="btn-share btn-share-twitter"
            target="_blank"
            :title="$t('common:shareButtons.shareTwitter')"
            :aria-label="$t('common:shareButtons.shareTwitter')"
          >
            <i class="icon"><icon-twitter /></i>
            <span>
              {{ $t('common:socialMedia.platforms.twitter') }}
            </span>
          </a>
        </li>
        <li>
          <button
            v-if="showPrintButton"
            type="button"
            class="btn-share print-button"
            :title="$t('common:shareButtons.printPage')"
            :aria-label="$t('common:shareButtons.printPage')"
            @click="printPage()"
          >
            <i class="icon "><icon-print /></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconBrandsFacebookMessenger from 'ICON:IconBrandsFacebookMessenger';
import IconTwitter from 'ICON:IconTwitter';
import IconBrandsFacebook from 'ICON:IconBrandsFacebook';
import IconWhatsapp from 'ICON:IconWhatsapp';
import IconSms from 'ICON:IconSms';
import IconEnvelopeAlternativeTwo from 'ICON:IconEnvelopeAlternativeTwo';
import IconPrint from 'ICON:IconPrint';
import { printAction } from 'mixins/PrintPage';

export default {
  name: 'SocialShareButtons',
  components: {
    IconBrandsFacebook,
    IconBrandsFacebookMessenger,
    IconTwitter,
    IconWhatsapp,
    IconSms,
    IconEnvelopeAlternativeTwo,
    IconPrint,
  },
  mixins: [printAction],
  props: {
    className: {
      type: String,
      default: 'aside-share',
    },
    spaced: {
      type: Boolean,
      default: false,
    },
    buildLinkEmail: {
      type: String,
      default: '',
    },
    buildLinkSms: {
      type: String,
      default: '',
    },
    buildLinkWaMobile: {
      type: String,
      default: '',
    },
    buildLinkTwitter: {
      type: String,
      default: '',
    },
    buildLinkFb: {
      type: String,
      default: '',
    },
    buildLinkFbMsg: {
      type: String,
      default: '',
    },
    showPrintButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped> // client specific scss is added at the end

// $color_social_facebook: #3b5998;
// $color_social_twitter: #00aced;
// $color_social_instagram: #125688;
// $color_social_pinterest: #cb2027;
// $color_social_youtube: #bb0000;
// $color_social_whatsapp: #34af23;

.btn-share {
  span {
    display: none;
  }
}

.btns-share {
  margin: 0;
  padding: 0;
  text-align: center;
  li {
    margin: 0;
    display: inline-block;
  }
}

/* default: right side and on mobile below */
.aside-share {
  text-align: center;
  padding:  $half_margin_content 1em;
  margin: (-$margin_content) (-$margin_content) (-$margin_content);
  @media #{$media_md_max} {
    padding:  5px 1em;
    margin: 12px 0 12px;
  }
  box-shadow: none;

  .btn-share {
    background: none;
    margin: 0;

    .icon {
      color: $color_ci_complement_400;

      @include font_size_xl;

      line-height: 1em;
      padding: 0.15em 0.35em;
      height: 1em;
    }
  }
}

/* modal */
.modal-share {
  .btns-share {
    margin: 0;
    padding: 0 2em 1em;
    li {
      list-style: none;
      padding: 0;
      margin: 10px 0;
      display: block;
    }
  }
  .btn-share {
    color: #fff;
    @extend .btn;
    background: $color_ci_complement;
    text-align: center;
    display: block;
    @include text_shadow;
    padding: .3em .5em;
    @include radius(var(--border_radius));
    svg {
      @include drop_shadow_light;
    }
    #app:not(.isTouchDevice) &:hover {
      color: #fff;
    }
    .icon {
      margin: 0 .15em 0 0;
    }
    span {
      display: inline;
    }
  }
  .btn-share-whatsapp {
    background: $color_social_whatsapp;
  }
  .btn-share-facebook {
    background: $color_social_facebook;
  }
  .btn-share-twitter {
    background: $color_social_twitter;
  }
}
.print-button {
  cursor: pointer;
}

</style>
<style lang="scss" scoped src='@/scss/components/SocialShareButtons.scss'></style>
<style lang="scss" scoped src='scss/components/SocialShareButtons.scss' clientextend></style>
